<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'p2p-lending',
};
</script>
